import { render } from "./LearningView.vue?vue&type=template&id=50fc31c6"
import script from "./LearningView.vue?vue&type=script&lang=js"
export * from "./LearningView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__